import { useTranslation } from '../i18n/useTranslation';
import { AppLayout } from '../components/templates/AppLayout/AppLayout';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/Sidebar';
import { PageContent } from '../components/templates/PageContent/PageContent';
import { PageHeader } from '../components/templates/PageHeader/PageHeader';
import { AdminArea } from '../components/admin/AdminArea';
import { AnalyticsWorkbench } from '../components/analytics/AnalyticsWorkbench';

/**
 * Admin → Analytics: questions over the whole database (all users; credential
 * columns blocked). Every query is written to the audit log by the API.
 */
export function AdminAnalyticsPage() {
  const { t } = useTranslation();

  return (
    <AppLayout
      header={<Header />}
      sidebar={<Sidebar />}
      main={
        <PageContent width="wide">
          <PageHeader title={t('adminArea.title')} description={t('adminArea.analytics.description')} />
          <AdminArea>
            <AnalyticsWorkbench scope="admin" />
          </AdminArea>
        </PageContent>
      }
    />
  );
}

export default AdminAnalyticsPage;
